import * as React from "react";
import { Container, TitleArea, OptionsArea } from "./Styled";
import Title from "../Title/Title";
import { OptionsToolTip } from "../optionsToolTip/OptionsToolTip"
type HeaderProps = {
    onDelete: () => void;
    title: string
}
  
const Header: React.FunctionComponent<HeaderProps> = ({title, onDelete}) => {
  return (
    <Container>
      <TitleArea><Title>{title}</Title></TitleArea>
      <OptionsArea><OptionsToolTip onDelete={onDelete}/></OptionsArea>
    </Container>
  );
};

export default Header;
